import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyAccountComponent } from './components/my-account/my-account.component';
import { FinalizeAccountRoutingModule } from './finalize-account-routing.module';
import { AccountConfirmationComponent } from './components/account-confirmation/account-confirmation.component';
import { AccountDocumentsComponent } from './components/account-documents/account-documents.component';
import { AccountBankInformationComponent } from './components/account-bank-information/account-bank-information.component';
import { AccountBillingAddressComponent } from './components/account-billing-address/account-billing-address.component';
import { AccountShippingAddressComponent } from './components/account-shipping-address/account-shipping-address.component';
import { AccountInformationComponent } from './components/account-information/account-information.component';
import { ReactiveFormsModule} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { CustomDateAdapter } from '../../helpers/custom-date-adapter';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [
    MyAccountComponent,
    AccountConfirmationComponent,
    AccountDocumentsComponent,
    AccountBankInformationComponent,
    AccountBillingAddressComponent,
    AccountShippingAddressComponent,
    AccountInformationComponent
  ],
    imports: [
        CommonModule,
        FinalizeAccountRoutingModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatDatepickerModule,
        MatIconModule,
        MatInputModule,
        SharedModule
    ],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'fr-FR'},
    {provide: DateAdapter, useClass: CustomDateAdapter},
  ]
})
export class FinalizeAccountModule { }
